import type { Nullable, TimeTempPair } from '$lib/types/RoastLog';
import * as d3 from 'd3';

export const getXAxisBoundsAndTicks = (data: TimeTempPair[], xMax: number) => {
  const xm = getMaxXValueFromData(data);
  if (xm <= xMax) {
    return {
      redrawChart: false,
      ticks: null,
      xUpperBound: xMax
    };
  }

  // Round up to the next next whole minute
  const xUpperBound = Math.ceil(xm / 60) * 60;
  // creates an array of tick values every minute: [0, 60, 120, 180, 240, ...]
  const ticks = Array.from({ length: Math.floor(xUpperBound / 60) + 1 }).map((_, i) => i * 60);

  return {
    redrawChart: true,
    ticks,
    xUpperBound
  };
};

export const getYAxisBounds = (
  data: (TimeTempPair[] | null)[],
  roundingFactor = 10
): TimeTempPair => {
  // Filter out nulls and flatten in one step
  const validPoints = data
    .filter((arr): arr is TimeTempPair[] => arr !== null)
    .flat()
    .map((pair) => pair[1]);

  const yMin = d3.min(validPoints) ?? 0; // Provide fallback if undefined
  const yMax = d3.max(validPoints) ?? 0;

  // return lowerBound, upperBound
  return [
    Math.max(0, Math.floor(yMin / roundingFactor) * roundingFactor),
    Math.ceil(yMax / roundingFactor) * roundingFactor
  ];
};

const getMaxXValueFromData = (data: TimeTempPair[]): number => {
  const dataPoint = data[data.length - 1];
  if (dataPoint) {
    return dataPoint[0];
  }
  return -1;
};
